import serviceAPI from '@/services/services/heatingignition/properties.service';
import { AUTHORIZATION_MODULE_PATH } from '@/store/modules/authorization';
import BaseModule from '@/store/baseModule';
import BaseModulePlugins from '@/store/baseModule/plugins';
import registerTabModule from '@/store/TabModule';
import { TRANSMITTER_TYPES } from '@/store/modules/properties/constants';
import getPropertiesAdditionnalData from '@/services/services/heatingignition/assets_properties_data.service';
import { getPredityPropertiesAdditionnalData } from '@/services/services/heatingignition/assets_predity_properties.service';
import makeQueryParams from './makeQueryParams';

const attributesObjRef = {
  remoteEnabled: {
    serverSide: true,
    type: '$specific',
    values: [
      { id: true, name: 'Oui' },
      { id: false, name: 'Non' },
    ],
  },
  'setupParam.activation_type': {
    serverSide: true,
    values: [
      { id: 'Technicien', name: 'Technicien' },
      { id: 'PEM', name: 'PEM' },
      { id: 'Autonome', name: 'Autonome' },
    ],
  },
  'setupParam.transmitter_type': {
    serverSide: true,
    autocomplete: true,
    values: TRANSMITTER_TYPES,
  },
};

function SET_PROPERTIES_DATA(state, propertiesData) {
  let items = state.items.data;

  items = items.map((item) => {
    const property = propertiesData.find(
      (prop) => prop.property_id === item.id
    );

    return {
      ...item,
      entity_shortname: property.entity_shortname,
      entity_name: property.entity_name,
      mnt_responsible_technician: property.mnt_responsible_technician,
      mnt_responsible_phone: property.mnt_responsible_phone,
      mnt_resp_buddy: property.mnt_resp_buddy,
      mnt_resp_buddy_phone: property.mnt_resp_buddy_phone,
      purpose: property.purpose,
      market_type: property.market_type,
      top_p1: property.top_p1,
    };
  });
  state.items.data = items;
}

function SET_PREDITY_PROPERTIES_DATA(state, propertiesData) {
  let items = state.items.data;

  items = items.map((item) => {
    const property = propertiesData.find(
      (prop) => prop.property_id === item.id
    );
    return {
      ...item,
      ignition_capability: property?.remote.ignition_capability,
      stc: property?.remote.stc,
    };
  });
  state.items.data = items;
}
export default (store) => {
  store.registerModule(
    ['properties', 'ignitions'],
    new BaseModule({
      attributesObjRef,
      searchAttributesArray: [
        'code',
        'shortname',
        'name',
        'city',
        'postal_code',
        'street',
      ],
      serviceAPI,
      customMutations: {
        SET_PROPERTIES_DATA,
        SET_PREDITY_PROPERTIES_DATA,
      },

      makeQueryParams,
    })
  );

  const basePlugin = new BaseModulePlugins({
    module: 'properties/ignitions',
    store,
  });
  basePlugin.initAttributeFiltersWhenAttributesObjRefIsLoaded({});
  basePlugin.persistVuexMutationsToLocalStorage(['SET_ATTRIBUTES_OBJ']);
  basePlugin.onInit(() => {
    if (store.getters[`${AUTHORIZATION_MODULE_PATH}/hasHIS`]) {
      basePlugin.loadItemsOnCurrentEntityChange();
    }

    basePlugin.onItemsLoaded((items) => {
      getPropertiesAdditionnalData(items)
        .then(async (resultList) => {
          store.commit('properties/ignitions/SET_PROPERTIES_DATA', resultList);
        })
        .catch((err) => {
          store.dispatch('snackbar/setError', err);
        });
      getPredityPropertiesAdditionnalData(items)
        .then(async (resultList) => {
          store.commit(
            'properties/ignitions/SET_PREDITY_PROPERTIES_DATA',
            resultList
          );
        })
        .catch((err) => {
          store.dispatch('snackbar/setError', err);
        });
    });
  });

  registerTabModule({
    namespace: ['properties', 'tabs'],
    tabs: ['properties', 'properties/ignitions'],
    store,
  });
};
